"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2; /**
                     * TODO: Check possibility to use vendor component
                     * https://github.com/nkbt/react-copy-to-clipboard instead. As it also built
                     * on top of "copy-to-clipboard" library.
                     */

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCopyToClipboard = require("react-copy-to-clipboard");

var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require("react-bootstrap");

require("query-command-supported/src/queryCommandSupported");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopyToClipboard = (_temp2 = _class = function (_Component) {
  _inherits(CopyToClipboard, _Component);

  function CopyToClipboard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CopyToClipboard.__proto__ || Object.getPrototypeOf(CopyToClipboard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      copied: false
    }, _this.handleCopy = function () {
      _this.setState({
        copied: true
      });

      setTimeout(function () {
        _this.setState({ copied: false });
      }, 2000);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          className = _props.className,
          value = _props.value;
      var copied = this.state.copied;


      return _react2.default.createElement(
        _reactCopyToClipboard2.default,
        {
          className: (0, _classnames2.default)("erg-components-CopyToClipboard input-group", className),
          onCopy: this.handleCopy,
          text: value },
        _react2.default.createElement(
          _reactBootstrap.FormGroup,
          null,
          _react2.default.createElement(
            _reactBootstrap.InputGroup,
            null,
            _react2.default.createElement(_reactBootstrap.FormControl, {
              id: "clipboard",
              readOnly: true,
              type: "text",
              value: value }),
            _react2.default.createElement(
              _reactBootstrap.InputGroup.Button,
              null,
              _react2.default.createElement(
                _reactBootstrap.Button,
                {
                  bsStyle: copied ? "success" : "default" },
                _react2.default.createElement(_reactBootstrap.Glyphicon, {
                  glyph: copied ? "ok" : "copy" })
              )
            )
          )
        )
      );
    }
  }]);

  return CopyToClipboard;
}(_react.Component), _class.displayName = "CopyToClipboard", _class.propTypes = {
  className: _propTypes2.default.string,
  value: _propTypes2.default.string.isRequired
}, _temp2);
exports.default = CopyToClipboard;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/CopyToClipboard.js
 ** module id = 780
 ** module chunks = 0
 **/